// constants
import { RadioActionTypes } from './constants';

export interface RadioActionType<TPayload> {
    type:
    RadioActionTypes.Radiobutton_GET_LIST
    | RadioActionTypes.Radiobutton_GET_LIST_SUCCESS
    

    payload?: TPayload;
}

export const changeRadiosGetAction = (): RadioActionType<any> => ({
    type: RadioActionTypes.Radiobutton_GET_LIST,
    //payload: layout,
});

export const changeRadiosGetSuccessAction = (layout: any): RadioActionType<any> => ({
    type: RadioActionTypes.Radiobutton_GET_LIST_SUCCESS,
    payload: layout,
});


